import axios from "axios";
import { toast } from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_ORDERS_REQUEST = "FETCH_ORDERS_REQUEST";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";

export const UPDATE_DELIVERY_INFO_REQUEST = "UPDATE_DELIVERY_INFO_REQUEST";
export const UPDATE_DELIVERY_INFO_SUCCESS = "UPDATE_DELIVERY_INFO_SUCCESS";
export const UPDATE_DELIVERY_INFO_FAILURE = "UPDATE_DELIVERY_INFO_FAILURE";

export const fetchOrders = () => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_REQUEST });
  const token = localStorage.getItem('token'); // Get token from localStorage
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/adminOrderStatus`, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });
    dispatch({ type: FETCH_ORDERS_SUCCESS, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to fetch orders");
    dispatch({ type: FETCH_ORDERS_FAILURE, payload: error.message });
  }
};

export const updateDeliveryInfo = (orderId, deliveryData) => async (dispatch) => {
  dispatch({ type: UPDATE_DELIVERY_INFO_REQUEST });
  const token = localStorage.getItem('token');
  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/orders/updateDeliveryInfo/${orderId}`,
      deliveryData,
      { headers: { authorization: `${token}` } }
    );
    dispatch({ type: UPDATE_DELIVERY_INFO_SUCCESS, payload: { orderId, deliveryData } });
    toast.success("Delivery info updated successfully");
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    toast.error(errorMessage);
    dispatch({ type: UPDATE_DELIVERY_INFO_FAILURE, payload: errorMessage });
    throw error;
  }
};

